import React from "react";
import { Link } from "react-router-dom";
import styles from "../styles/components/Skills.module.css";

import { skills } from "../data";

const Skills = () => {
    const {languages, tools, api, lang} = skills;

    return (
        <div className={styles.skills}>
            <h2 className={styles.skillsTitle}>My Skills</h2>
            <p className={styles.skillsDescription}>You can click on any of my skills to learn more about them and see how i used them</p>
            <div className={styles.section}>
                <h3>Languages and Frameworks</h3>
                <div className={styles.skillsGrid}>
                    {languages.map((skill) => (
                        <Link
                            key={skill.name}
                            className={styles.skillCard}
                            to={"/skill/" + skill.link}
                        >
                            <img
                                src={skill.icon}
                                alt={skill.name}
                                className={styles.skillIcon}
                            />
                            <p className={styles.skillName}>{skill.name}</p>
                        </Link>
                    ))}
                </div>
            </div>
            <div className={styles.section}>
                <h3>Langs and work environments</h3>
                <div className={styles.skillsGrid}>
                    {lang.map((skill) => (
                        <Link
                            key={skill.name}
                            className={styles.skillCard}
                            to={"/skill/" + skill.link}
                        >
                            <img
                                src={skill.icon}
                                alt={skill.name}
                                className={styles.skillIcon}
                            />
                            <p className={styles.skillName}>{skill.name}</p>
                        </Link>
                    ))}
                </div>
            </div>
            <div className={styles.section}>
                <h3>Tools and Team Work</h3>
                <div className={styles.skillsGrid}>
                    {tools.map((skill) => (
                        <Link
                            key={skill.name}
                            className={styles.skillCard}
                            to={"/skill/" + skill.link}
                        >
                            <img
                                src={skill.icon}
                                alt={skill.name}
                                className={styles.skillIcon}
                            />
                            <p className={styles.skillName}>{skill.name}</p>
                        </Link>
                    ))}
                </div>
            </div>
            <div className={styles.section}>
                <h3>Api and services Integrations</h3>
                <div className={styles.skillsGrid}>
                    {api.map((skill) => (
                        <Link
                            key={skill.name}
                            className={styles.skillCard}
                            to={"/skill/" + skill.link}
                            
                        >
                            <img
                                src={skill.icon}
                                alt={skill.name}
                                className={styles.skillIcon}
                            />
                            <p className={styles.skillName}>{skill.name}</p>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Skills;
